import React from 'react';
import {
  Box,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  CloseButton,
} from '@chakra-ui/react';

const UpdateNotification: React.FC<{ dismissMessage: () => void }> = ({
  dismissMessage,
}) => (
  <Box p={2} position="fixed" top={0} left={0} right={0} zIndex="banner">
    <Alert
      status="info"
      border={1}
      borderColor="blue.400"
      borderWidth={1}
      borderStyle="solid"
      px={3}
      py={4}
      borderRadius={2}
      alignItems="center"
      onClick={dismissMessage}
      cursor="pointer"
    >
      <AlertIcon />
      <AlertTitle>A new version of Datapoints is available.</AlertTitle>
      <AlertDescription flexGrow={1}>
        Refresh your browser to update, or click to dismiss this message.
      </AlertDescription>
      <CloseButton onClick={dismissMessage} />
    </Alert>
  </Box>
);

export default UpdateNotification;
